import Layout from "Layout";
import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { getGallery } from "services/apiRoutes";
import SkeletonMaincard from "skeletons/SkeletonMaincard";

export default function Gallery() {
  const { slug } = useParams();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchGallery = useCallback(async () => {
    setLoading(true);
    const res = await getGallery(slug);
    if (!res.error) {
      setImages(res.data.data || []);
    }
    setLoading(false);
  }, [slug]);

  useEffect(() => {
    fetchGallery();
  }, [fetchGallery]);

  return (
    <Layout>
      <div className="px-5 xl:pt-56 pt-28 kegiatan-wrapper xl:px-99 min-h-screen pb-20">
        <div className="mb-16">
          <h1 className="text-3xl font-extrabold xl:text-7xl text-gray-900 tracking-tight">
            Gallery Gampong
          </h1>
          <p className="mt-4 text-lg text-gray-500 max-w-2xl">
            Kumpulan dokumentasi foto kegiatan dan suasana Gampong.
          </p>
        </div>

        {loading ? (
          <div className="gap-5 space-y-5 md:grid md:grid-cols-2 xl:grid-cols-3 xl:space-y-0">
            {[1, 2, 3, 4, 5, 6].map((x) => (
              <SkeletonMaincard key={x} />
            ))}
          </div>
        ) : images.length === 0 ? (
          <div className="text-center py-20 bg-gray-50 rounded-[2.5rem] border-2 border-dashed border-gray-200">
            <p className="text-gray-400 font-medium">Belum ada foto di gallery.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {images.map((item, index) => (
              <div 
                key={item.id || index}
                className="group relative bg-white rounded-[2rem] overflow-hidden shadow-sm hover:shadow-2xl hover:shadow-primary/10 transition-all duration-500 transform hover:-translate-y-2 border border-gray-100"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={item.imageUrl || item.url_gambar}
                    alt={item.title || "Gallery Image"}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-8">
                    <h3 className="text-white font-bold text-xl transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      {item.title || "Foto Gampong"}
                    </h3>
                    <p className="text-white/70 text-sm mt-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-75">
                      {item.date || new Date(item.createdAt?.seconds * 1000).toLocaleDateString() || ""}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
